import GroupPostCardView from "./GroupPostCardView";

export default GroupPostCardView;